import React from 'react';

interface NoInternetPageProps {
  onRetry?: () => void;
}

const NoInternetPage: React.FC<NoInternetPageProps> = ({ onRetry }) => {
  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: '#1a1a2e',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999,
      flexDirection: 'column',
      color: '#fff',
      fontFamily: 'Arial, sans-serif'
    }}>
      <div style={{
        textAlign: 'center',
        padding: '20px'
      }}>
        {/* No Internet Icon */}
        <div style={{
          fontSize: '80px',
          marginBottom: '20px',
          opacity: 0.8
        }}>
          📡❌
        </div>

        {/* Title */}
        <h1 style={{
          fontSize: '32px',
          marginBottom: '15px',
          fontWeight: 'bold',
          color: '#fff'
        }}>
          No Internet Connection
        </h1>

        {/* Message */}
        <p style={{
          fontSize: '18px',
          marginBottom: '30px',
          color: '#b0b0b0',
          maxWidth: '500px'
        }}>
          Please check your internet connection and try again.
          <br />
          The page will reload automatically once connection is restored.
        </p>

        {/* Loading Animation */}
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          gap: '10px',
          marginBottom: '30px'
        }}>
          <div className="loading-dot" style={{
            width: '12px',
            height: '12px',
            backgroundColor: '#4CAF50',
            borderRadius: '50%',
            animation: 'pulse 1.5s ease-in-out infinite'
          }}></div>
          <div className="loading-dot" style={{
            width: '12px',
            height: '12px',
            backgroundColor: '#4CAF50',
            borderRadius: '50%',
            animation: 'pulse 1.5s ease-in-out 0.2s infinite'
          }}></div>
          <div className="loading-dot" style={{
            width: '12px',
            height: '12px',
            backgroundColor: '#4CAF50',
            borderRadius: '50%',
            animation: 'pulse 1.5s ease-in-out 0.4s infinite'
          }}></div>
        </div>

        {/* Retry Button */}
        {onRetry && (
          <button
            onClick={onRetry}
            style={{
              padding: '12px 40px',
              fontSize: '16px',
              backgroundColor: '#4CAF50',
              color: '#fff',
              border: 'none',
              borderRadius: '25px',
              cursor: 'pointer',
              fontWeight: 'bold',
              transition: 'background-color 0.3s ease',
              boxShadow: '0 4px 15px rgba(76, 175, 80, 0.3)'
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.backgroundColor = '#45a049';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.backgroundColor = '#4CAF50';
            }}
          >
            Try Again
          </button>
        )}

        {/* Tips */}
        <div style={{
          marginTop: '40px',
          fontSize: '14px',
          color: '#888'
        }}>
          <p style={{ marginBottom: '8px' }}>💡 <strong>Quick Tips:</strong></p>
          <ul style={{
            listStyle: 'none',
            padding: 0,
            lineHeight: '2'
          }}>
            <li>• Check if WiFi or mobile data is enabled</li>
            <li>• Try switching between WiFi and mobile data</li>
            <li>• Check if other apps or websites are working</li>
          </ul>
        </div>
      </div>

      {/* CSS Animation */}
      <style>{`
        @keyframes pulse {
          0%, 100% {
            opacity: 0.3;
            transform: scale(0.8);
          }
          50% {
            opacity: 1;
            transform: scale(1.2);
          }
        }
      `}</style>
    </div>
  );
};

export default NoInternetPage;

